import { request } from 'utils';

// api call
export const get = (path) => request({ url: `report/${path}`, method: 'get' }).then(res => res).catch(err => err);
export const post = (path, obj) => request({ url: `report/${path}`, method: 'post', data: obj }).then(res => res).catch(err => err);